import { urls } from '@getstream/ui-library/build';

export const conclusion = {
  conclusion:
    "This tutorial showed you the basics of what's possible with Stream. Setting up a Video & Audio app on your own can take months. Stream makes it easy and gives you the tools to improve user engagement within your app. Time to add Video & Audio to your app! SDK are available for Flutter, Android, iOS and React with React Native coming soon!",
  components: [
    { icon: 'IconIos', label: 'IOS', to: urls.video.tutorials.ios },
    { icon: 'IconReact', label: 'IOS/SwiftUI', to: urls.video.tutorials.react },
    { icon: 'IconFlutter', label: 'Flutter', to: urls.video.tutorials.flutter },
    { icon: 'IconAndroid', label: 'Android', to: urls.video.tutorials.android },
  ],
  docs: {
    label: 'Video Docs',
    to: urls.video.docs,
  },
};
